<!-- 编辑用户信息 -->
<template>
  <a-modal
    title="编辑信息"
    :visible="visible"
    v-if="visible"
    @ok="onSave"
    width="800px"
    :closable="false"
  >
    <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules">
      <a-row :gutter="20">
        <a-col span="12">
          <a-form-model-item label="所属部门" prop="departmentName">
            <InputText v-model="ruleForm.departmentName" allowClear />
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item label="身份证号" prop="userIdCard">
            <InputText v-model="ruleForm.userIdCard" allowClear />
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item label="手机号" prop="phone">
            <InputText v-model="ruleForm.phone" allowClear />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="20"></a-row>
    </a-form-model>

    <div style="color: #f5222d; font-size: 12px">
      * 查询个人账号，请补充完整个人信息。
    </div>

    <template slot="footer">
      <a-button type="primary" @click.stop="onSave">保 存</a-button>
    </template>
  </a-modal>
</template>

<script>
import { mapState } from "vuex";
import InputText from "@/components/form/InputText"; // 输入框组建
import API from "@/api/sysManage.js"; // 请求接口
export default {
  components: {
    InputText,
  },
  props: {
    // 表格选中数据
    modalData: {
      type: Object,
      required: false,
    },
    modalFlag: Boolean,
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    // 统一社会信用代码/身份证号 - 校验
    const checkSfz = (rule, value, callback) => {
      let _IDRe18 =
        /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      // 校验身份证
      if (value === "") {
        callback(new Error("请输入身份证号!"));
      } else if (!_IDRe18.test(value)) {
        callback(new Error("请输入正确的格式"));
      } else {
        callback();
      }
    };

    const checkPhone = (rule, value, callback) => {
      let telephone = /^1[3-9][0-9]{9}$/; // 手机
      if (value === "") {
        callback(new Error("请输入手机号!"));
      } else if (!telephone.test(value)) {
        callback(new Error("请输入正确的格式"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        departmentName: "", // 所属部门
        userIdCard: "",
        phone: "",
        id: "",
      },
      visible: false,
      rules: {
        departmentName: [
          { required: true, message: "请输入所属部门!", trigger: "change" },
        ],
        userIdCard: [
          { required: true, validator: checkSfz, trigger: "change" },
        ],
        phone: [{ required: true, validator: checkPhone, trigger: "change" }],
      },
    };
  },
  methods: {
    // 保存
    onSave() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.submit();
        }
      });
    },
    submit() {
      this.loading = true;
      let params = {
        data: {
          params: {
            ...this.ruleForm,
          },
        },
      };

      API.mergeUser(params, (callback) => {
        this.loading = false;
        if (callback.status == "S") {
          let str = "保存成功";
          this.$message.destroy();
          this.$message.success(`${str}`);
          this.$emit("handleFlag", false, {}, "ok");
        }
      });
    },
  },
  watch: {
    modalFlag(newVal, oldVal) {
      this.visible = newVal;
      if(newVal) {
        this.ruleForm.departmentName = this.userInfo.departmentName || '';
        this.ruleForm.userIdCard = this.userInfo.userIdCard || '';
        this.ruleForm.phone = this.userInfo.phone || '';
        this.ruleForm.id = this.userInfo.userId || '';
      }
    },
  },
};
</script>
